import type { PromotedPriceApiResponse } from './types'
import type { PromotedPrice } from '@/scopes/prices/domain/promoted-price/types'

export interface PromotedPriceResponseMapper {
  map: (response: PromotedPriceApiResponse) => PromotedPrice
}

export function createPromotedPriceResponseMapper(): PromotedPriceResponseMapper {
  function map(response: PromotedPriceApiResponse): PromotedPrice {
    const {
      accommodationId,
      duration,
      includedServices,
      featuredFilters,
      price,
      yieldCampaignLogo,
      yieldCampaignCode,
      departureDate,
      acmInformation,
      outboundDepartureAirportName,
      paymentMethod,
      countdown,
      hasExternalFlight,
    } = response

    return {
      accommodationId,
      duration,
      services: includedServices,
      filters: featuredFilters,
      price: {
        value: price.value,
        averagePrice: price.averagePrice,
        totalPrice: price.totalPrice,
        originalValue: price.originalValue,
        originalAveragePrice: price.originalAveragePrice,
        originalTotalPrice: price.originalTotalPrice,
        discountPercentage: price.discountPercentage,
        supportText: price.legend,
      },
      legacyDepartureDate: {
        date: departureDate.raw,
        formatted: departureDate.humanized,
      },
      departureDate: new Date(departureDate.raw),
      transportType: acmInformation?.transportType || '',
      mealplan: acmInformation?.mealplanCode || '',
      acm: acmInformation,
      departureAirport: outboundDepartureAirportName,
      ...(yieldCampaignLogo && { campaignImage: yieldCampaignLogo }),
      ...(yieldCampaignCode && { campaignId: yieldCampaignCode }),
      ...(countdown && { campaignCountDown: countdown }),
      hasExternalFlight,
      paymentMethod,
    }
  }

  return {
    map,
  }
}
